import { HomeChargingSupportingDocument } from "./homeChargingSupportingDocumentsAPI";

export const fakeHomeChargingSupportingDocumentsByMonth: Record<
  number,
  HomeChargingSupportingDocument[]
> = {
  7: [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      chargesCount: 7,
      totalEnergy: 131.2,
      reimbursementAmount: 26.24,
      supportingDocument: {
        createdAt: "2026-09-01T09:00:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      chargesCount: 3,
      totalEnergy: 64.8,
      reimbursementAmount: 12.96,
      supportingDocument: {
        createdAt: "2026-09-01T09:00:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      chargesCount: 4,
      totalEnergy: 70.3,
      reimbursementAmount: 14.06,
      supportingDocument: {
        createdAt: "2026-09-02T14:30:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      chargesCount: 6,
      totalEnergy: 118.9,
      reimbursementAmount: 23.78,
      supportingDocument: {
        createdAt: "2026-09-02T14:30:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000006",
      firstName: "Lucas",
      lastName: "Martin",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000007",
      firstName: "Sophie",
      lastName: "Lefèvre",
      chargesCount: 10,
      totalEnergy: 205.7,
      reimbursementAmount: 41.14,
      supportingDocument: {
        createdAt: "2026-09-04T10:15:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000008",
      firstName: "Léa",
      lastName: "Garnier",
      chargesCount: 8,
      totalEnergy: 160.4,
      reimbursementAmount: 32.08,
      supportingDocument: null,
    },
  ],
  8: [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      chargesCount: 8,
      totalEnergy: 154.8,
      reimbursementAmount: 30.96,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      chargesCount: 2,
      totalEnergy: 108.6,
      reimbursementAmount: 14.24,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      chargesCount: 3,
      totalEnergy: 61,
      reimbursementAmount: 12.2,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      chargesCount: 3,
      totalEnergy: 52.9,
      reimbursementAmount: 10.58,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      chargesCount: 5,
      totalEnergy: 96.4,
      reimbursementAmount: 19.28,
      supportingDocument: {
        createdAt: "2026-10-02T08:00:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000006",
      firstName: "Lucas",
      lastName: "Martin",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000007",
      firstName: "Sophie",
      lastName: "Lefèvre",
      chargesCount: 12,
      totalEnergy: 248.3,
      reimbursementAmount: 49.66,
      supportingDocument: {
        createdAt: "2026-10-01T15:20:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000009",
      firstName: "Mohamed",
      lastName: "Benali",
      chargesCount: 1,
      totalEnergy: 7.4,
      reimbursementAmount: 1.48,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000010",
      firstName: "Inès",
      lastName: "Rousseau-Lambert",
      chargesCount: 6,
      totalEnergy: 132.5,
      reimbursementAmount: 26.5,
      supportingDocument: {
        createdAt: "2026-10-03T09:45:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000011",
      firstName: "Hugo",
      lastName: "Fontaine",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000008",
      firstName: "Léa",
      lastName: "Garnier",
      chargesCount: 9,
      totalEnergy: 187.1,
      reimbursementAmount: 37.42,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000012",
      firstName: "Nathalie",
      lastName: "Chevalier",
      chargesCount: 4,
      totalEnergy: 73.2,
      reimbursementAmount: 14.64,
      supportingDocument: {
        createdAt: "2026-10-05T16:10:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
  ],
  9: [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      chargesCount: 3,
      totalEnergy: 58.2,
      reimbursementAmount: 11.64,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      chargesCount: 1,
      totalEnergy: 22.4,
      reimbursementAmount: 4.48,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      chargesCount: 2,
      totalEnergy: 31.5,
      reimbursementAmount: 6.3,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      chargesCount: 2,
      totalEnergy: 40.1,
      reimbursementAmount: 8.02,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000007",
      firstName: "Sophie",
      lastName: "Lefèvre",
      chargesCount: 5,
      totalEnergy: 102.6,
      reimbursementAmount: 20.52,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000009",
      firstName: "Mohamed",
      lastName: "Benali",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000010",
      firstName: "Inès",
      lastName: "Rousseau-Lambert",
      chargesCount: 3,
      totalEnergy: 61.7,
      reimbursementAmount: 12.34,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000008",
      firstName: "Léa",
      lastName: "Garnier",
      chargesCount: 4,
      totalEnergy: 79.3,
      reimbursementAmount: 15.86,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000012",
      firstName: "Nathalie",
      lastName: "Chevalier",
      chargesCount: 1,
      totalEnergy: 18.9,
      reimbursementAmount: 3.78,
      supportingDocument: null,
    },
  ],
};

export const fakeHomeChargingSupportingDocumentsMonths: string[] = [
  "2026-08-01T00:00:00.000Z",
  "2026-09-01T00:00:00.000Z",
  "2026-10-01T00:00:00.000Z",
];
